import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';
import SectionHeading from '@/components/feature/SectionHeading';

export default function DigestSection() {
  const primaryList = articles.slice(4, 9);
  const sideList = articles.slice(9, 12);

  return (
    <section id="digest" className="w-full bg-background-50 py-12 md:py-16 scroll-mt-32">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="深度爆料"
          title="不止一句话，把过程讲完整"
          description="对讨论密集的事件做完整复盘：从最初的爆料节点，到各方回应，再到目前仍未解决的分歧。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2 flex flex-col gap-4">
            {primaryList.map((item) => (
              <ArticleCard key={item.slug} article={item} variant="wide" />
            ))}
          </div>

          <aside className="flex flex-col gap-5">
            <div className="rounded-lg border border-background-200 bg-background-100 p-5">
              <h3 className="font-heading text-base font-bold text-foreground-950">
                <i className="ri-star-smile-line mr-1.5 text-secondary-600"></i>
                编辑推荐
              </h3>
              <ul className="mt-2">
                {sideList.map((item) => (
                  <li key={item.slug}>
                    <ArticleCard article={item} variant="compact" showCover={false} />
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <h3 className="font-heading text-base font-bold text-foreground-950">
                <i className="ri-price-tag-3-line mr-1.5 text-accent-600"></i>
                读者高频关注
              </h3>
              <div className="mt-3 flex flex-wrap gap-2">
                {['票数争议', '解约风波', '口碑两极', '价格承诺', '退票规则', '隐形加班', '撞图争议', '剪辑回应'].map(
                  (tag) => (
                    <Link
                      key={tag}
                      to="/#events"
                      className="px-3 py-1.5 text-xs rounded-full bg-secondary-50 text-secondary-900 border border-secondary-200 hover:bg-secondary-100 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {tag}
                    </Link>
                  ),
                )}
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}